// extracted by mini-css-extract-plugin
export var activeCourseTab = "index-module--activeCourseTab--c0d15";
export var courseCardImg = "index-module--courseCardImg--24cb6";
export var courseTab = "index-module--courseTab--43759";
export var smallImg = "index-module--smallImg--d0a7d";